import React, { useMemo } from "react";
import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { Accordions } from "../../../components/shared/Accordion/Accordions";
import {
  FAQAccordionWrapper,
  FAQSection,
  FAQSupportBody,
  FAQSupportLinks,
  FAQSupportSection,
  FAQSupportTitle,
  FAQTitle,
} from "./PhlebotomyFAQ.styles";
import { buildPhlebotomyFaqAccordionData } from "./phlebotomyFaqContent";
import {
  PHLEBOTOMY_SUPPORT_EMAIL,
  PHLEBOTOMY_SUPPORT_PHONE,
} from "./phlebotomySupportContact";

interface PhlebotomyFAQProps {
  onFAQClick?: (key: string) => void;
  onSupportEmailClick?: () => void;
  onSupportPhoneClick?: () => void;
}

const PhlebotomyFAQ: React.FC<PhlebotomyFAQProps> = ({
  onFAQClick,
  onSupportEmailClick,
  onSupportPhoneClick,
}) => {
  const { t } = useTranslation();
  const faqData = useMemo(() => buildPhlebotomyFaqAccordionData(t), [t]);

  return (
    <FAQSection aria-labelledby="phlebotomy-faq-title">
      <FAQTitle id="phlebotomy-faq-title">
        {t("phlebotomy.faq.panelTitle")}
      </FAQTitle>
      <FAQAccordionWrapper>
        <Accordions
          data={faqData}
          isLinked={false}
          size="small"
          onClick={onFAQClick}
        />
      </FAQAccordionWrapper>
      <FAQSupportSection>
        <FAQSupportTitle>{t("phlebotomy.faq.supportTitle")}</FAQSupportTitle>
        <FAQSupportBody>{t("phlebotomy.faq.supportMessage")}</FAQSupportBody>
        <FAQSupportLinks>
          <Typography
            component="a"
            href={`mailto:${PHLEBOTOMY_SUPPORT_EMAIL}`}
            onClick={onSupportEmailClick}
          >
            {t("phlebotomy.faq.supportEmail")}
          </Typography>
          <Typography component="span" aria-hidden="true">
            ·
          </Typography>
          <Typography
            component="a"
            href={`tel:${PHLEBOTOMY_SUPPORT_PHONE}`}
            onClick={onSupportPhoneClick}
          >
            {t("phlebotomy.faq.supportPhone")}
          </Typography>
        </FAQSupportLinks>
      </FAQSupportSection>
    </FAQSection>
  );
};

export default PhlebotomyFAQ;
